<div class="dsh-details-item-title">{{ title }}</div>
<div class="dsh-details-item-content">
    <ng-content></ng-content>
</div>
